import React from 'react';
import { getIsAdmin } from 'src/libraries/access.library';
import {
  IRequestFormMethods,
  IRequestAdminFormMethods,
} from 'src/models/request.model';
import FlightRequestAccountingForm from '../flight-request-accounting/flight-request-accounting-form/flight-request-accounting-form.component';
import FlightRequestAdmin from '../flight-request-admin/flight-request-admin.component';
import FlightRequestDateForm from '../flight-request-date/flight-request-date-form/flight-request-date-form.component';
import FlightRequestInformationForm from '../flight-request-information/flight-request-information-form/flight-request-information-form.component';
import FlightRequestRequestorForm from '../flight-request-requestor/flight-request-requestor-form/flight-request-requestor-form.component';
import FlightRequestEmergencyPocForm from '../flight-request-emergency-poc/flight-request-emergency-poc-form/flight-request-emergency-poc-form.component';

type IProps = (IRequestFormMethods | IRequestAdminFormMethods) & {
  isEdit: boolean;
  handlePast: (data: boolean) => void;
  handleDismiss: () => void;
};

const FlightRequestFormView: React.FC<IProps> = ({
  isEdit,
  control,
  handlePast,
  handleDismiss,
  ...props
}) => (
  <>
    <FlightRequestRequestorForm control={control} {...props} />
    <FlightRequestEmergencyPocForm control={control} {...props} />

    <FlightRequestDateForm
      {...props}
      control={control}
      isEdit={isEdit}
      handlePast={handlePast}
      handleDismiss={handleDismiss}
    />

    <FlightRequestAccountingForm control={control} {...props} />

    <FlightRequestInformationForm
      isEdit={isEdit}
      control={control}
      {...props}
    />

    {isEdit && getIsAdmin() && (
      <FlightRequestAdmin
        control={control as IRequestAdminFormMethods['control']}
        {...props}
      />
    )}
  </>
);

export default FlightRequestFormView;
